import { MarketExprtChargeCodesPanel } from "../MarketExprtChargeCodesPanel";
import { MarketExprtOutputFiltersPanel } from "../MarketExprtOutputFiltersPanel";
import { RateIndexControlMainPanel } from "../RateIndexControlMainPanel";
import { Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutGreenscreensControl extends Layout {
    checkbox10: Checkbox;
    checkbox11: Checkbox;
    checkbox12: Checkbox;
    checkbox13: Checkbox;
    checkbox14: Checkbox;
    checkbox15: Checkbox;
    checkbox16: Checkbox;
    checkbox17: Checkbox;
    checkbox18: Checkbox;
    checkbox19: Checkbox;
    checkbox1: Checkbox;
    checkbox20: Checkbox;
    checkbox21: Checkbox;
    checkbox22: Checkbox;
    checkbox23: Checkbox;
    checkbox24: Checkbox;
    checkbox25: Checkbox;
    checkbox26: Checkbox;
    checkbox27: Checkbox;
    checkbox28: Checkbox;
    checkbox29: Checkbox;
    checkbox2: Checkbox;
    checkbox30: Checkbox;
    checkbox31: Checkbox;
    checkbox32: Checkbox;
    checkbox33: Checkbox;
    checkbox35: Checkbox;
    checkbox36: Checkbox;
    checkbox37: Checkbox;
    checkbox38: Checkbox;
    checkbox39: Checkbox;
    checkbox3: Checkbox;
    checkbox40: Checkbox;
    checkbox41: Checkbox;
    checkbox42: Checkbox;
    checkbox43: Checkbox;
    checkbox44: Checkbox;
    checkbox4: Checkbox;
    checkbox5: Checkbox;
    checkbox6: Checkbox;
    checkbox7: Checkbox;
    checkbox8: Checkbox;
    checkbox9: Checkbox;
    checkboxUnitCount: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    labelAdditionalOptions: Label;
    labelMarketRateExport: Label;
    labelOutputSettings: Label;
    labelPricingandBidManagement: Label;
    labelRateOptions: Label;
    labelRateTypes: Label;
    layout1ChargeCodes: MarketExprtChargeCodesPanel;
    layoutOutputFilters: MarketExprtOutputFiltersPanel;
    layoutRateIndexGeneral: RateIndexControlMainPanel;
    marketRateExportSection: Panel;
    panel10: Panel;
    panel11: Panel;
    panel12: Panel;
    panel2: Panel;
    panel9: Panel;
    panelGreenscreens: Panel;
    rateIndexSection: Panel;
    sourceMarketrateExprt: DataSource;
    sourceRateIndexControl: DataSource;
    switchAutoRateRetreival: Switch;
    switchDisplaySellRates: Switch;
    switchDisplaySpotRates: Switch;
    switchEnableRateExport: Switch;
    switchGenerateMissingRatesforCurrentDate: Switch;
    switchRequestRateswithBatchProcess: Switch;
    switchUseMarketRateFuelSurcharge: Switch;
    textboxCustomerId: Textbox;
    textboxDefaultTrailerType: Textbox;
    textboxLagDays: Textbox;
    textboxProcessDays: Textbox;
    textboxRateGenerationPreference: Textbox;
    textboxRateRequestPref: Textbox;
    textboxSecondsToTimeout: Textbox;
}
